export default class BalanceUp{
    constructor({ priceList = [], clickHandler }){
        this.priceList = priceList;
        this.onClick = clickHandler;
    }

    render(container){
        container.innerHTML = '';

        const balanceUpElement = document.createElement('div');
        balanceUpElement.className = 'pricing-section';

        const header = document.createElement('h2');
        header.className = 'section-title';
        header.innerHTML = '<i class="fas fa-credit-card"></i> Пополнение баланса';

        balanceUpElement.appendChild(header);

        this.priceList.forEach(price => {
            const priceElement = this.createPriceElement(price.tokens, price.price);
            balanceUpElement.appendChild(priceElement);
        })

        container.appendChild(balanceUpElement);
    }

    createPriceElement(tokens, price){
        const element = document.createElement('div');
        element.className = 'tariff-card';
        const form = `
                <div class="tariff-tokens">
                    <div class="token-icon">
                        <i class="fas fa-gem"></i>
                    </div>
                    ${tokens}
                </div>
                <div class="tariff-price">${price} ₽</div>
                <button class="buy-button" data-tokens="${tokens}" data-price="${price}">
                    <i class="fas fa-shopping-cart"></i> Купить
                </button>
        `; 
        element.innerHTML = form;
        this.bindEvent(element, tokens, price);
        return element;
    }

    bindEvent(element, tokens, price){
        element.addEventListener('click', async () =>{
            const data = {
                // command: 'up_balance',
                tokens: tokens,
                price: price,
                // timestamp: new Date().toISOString(),
            };
            try{
                this.onClick(data);
            }catch{
                console.error('error sending data');
            }
        })
    }

                    // user: this.telegram.initDataUnsafe?.user,
                // timestamp: new Date().toISOString(),
                // additionalData: {
                //     platform: this.telegram.platform,
                //     version: this.telegram.version
                // }
}